import React, { useState } from 'react';
import Modal from '../../Modal';
import ProductWizard from './ProductWizard';

export default function ProductWizardCreateButton({ onComplete, label = 'Create Product' }) {
    const [isOpen, setIsOpen] = useState(false);

    const handleComplete = (product) => {
        setIsOpen(false);
        onComplete?.(product);
    };

    return (
        <>
            <button
                type="button"
                className="button primary"
                onClick={() => setIsOpen(true)}
            >
                <i className="fa-solid fa-plus"></i> {label}
            </button>

            <Modal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                title="Create New Product"
                size="large"
                closeOnOverlayClick={false}
            >
                {isOpen && (
                    <ProductWizard
                        modal={true}
                        onComplete={handleComplete}
                        onClose={() => setIsOpen(false)}
                    />
                )}
            </Modal>
        </>
    );
}
